export const config = {
    bar: { title: 'Letter-box Web' },
    header: { title: 'SRG Letterbox Web Playground', version: '0.0.4', description: 'Player version : ' },
    menu: {
        streams: {
            title: 'Streams',
            buttons: [
                { 'steamType': 'vod', 'title': 'VOD 19h30', 'type': "srgssr/urn", 'src': "urn:rts:video:10894383" },
                { 'steamType': 'vodToken', 'title': 'VOD Token', 'type': "srgssr/urn", 'src': "urn:rts:video:6255456" },
                {
                    'steamType': 'live',
                    'title': 'Live',
                    'type': 'srgssr/urn',
                    'src': "urn:srf:video:c4927fcf-e1a0-0001-7edd-1ef01d441651"
                },
                { 'steamType': 'livedvr', 'title': 'Live DVR', 'type': "srgssr/urn", 'src': "urn:rts:video:1967124" },
                { 'steamType': 'livedrmdvr', 'title': 'Live DRM DVR', 'type': "srgssr/urn", 'src': "urn:rts:video:3608506" },
                {
                    'steamType': 'livedrm',
                    'title': 'Live DRM',
                    'type': "srgssr/urn",
                    'src': "urn:srf:video:c4927fcf-e1a0-0001-7edd-1ef01d441651"
                },
                { 'steamType': 'aod', 'title': 'AOD', 'type': "srgssr/urn", 'src': "urn:rts:audio:9348470" },
                { 'steamType': 'liveaudio', 'title': 'Live Audio', 'type': "srgssr/urn", 'src': "urn:rts:audio:3262363" }
            ]
        },
        tools: {
            title: 'Tools',
            environments: {
                title: 'Environments',
                radioButtons: [{
                        title: 'test',
                        host:'il-test.srgssr.ch',
                    },
                    {
                        title: 'stage',
                        host:'il-stage.srgssr.ch',
                    },
                    {
                        title: 'prod',
                        host:'il.srgssr.ch',
                    },
                    {
                        title: 'mmf',
                        host:'play-mmf.herokuapp.com',
                    }]
            },
            lang: {
                title: 'Languages',
                radioButtons: [{
                        title: 'French',
                        code:'fr',
                    },
                    {
                        title: 'German',
                        code:'de',
                    },
                    {
                        title: 'Italian',
                        code:'it',
                    },
                    {
                        title: 'Romansh',
                        code:'rm',
                    },
                    {
                        title: 'English',
                        code:'en',
                    }
                ]
            }
        }
    }
};
